



//insta
// const insta = Vue.createApp({
//   data() {
//     return {
//       posts: "",
//       error: "",
//     };
//   },
//   created() {
//     this.getPosts();
//   },
//   methods: {
//     //投稿データ取得
//     getPosts: function () {
//       axios
//         .get(
//           "https://graph.facebook.com/v19.0/17841449936861923?fields=name%2Cmedia.limit(8)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Cthumbnail_url%7D&access_token=EAAFNrzoP2TgBAG2W58wxB0OxnZAfTBNfXzTAOKHs17745BwhtRaRv7ZCYMVUbe2nELkzjBMUEOqBbNa7ZCZCfIQ0LJF8ZA41dny6oWr6tjwjKilT0ITsQm8A1uL6z2sS1ZCialeXjwCBmjXxTjL5ZAjiyUcj24xz95GJtSZAEKxKkZBsxTCecsFPoI8SCzkcaKXMZD",
//           {
//             params: {
//               // 取得する記事数
//               per_page: 24,
//             },
//           }
//         )
//         .then((response) => {
//           this.posts = response.data.media.data;
//           // console.log(this.posts);
//           var logo =
//             '<div class="insta_item"><a class="insta_logo" href="https://www.instagram.com/kawaishihonke1863/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg></a></div>';
//           $("#instafeed").append(logo);
//         })
//         .catch((error) => {
//           this.error = "記事を取得できません";
//         });
//     },
//   },
// });

const insta = Vue.createApp({
  data() {
    return {
      posts: [],
      error: "",
    };
  },
  created() {
    this.getPosts();
  },
  methods: {
    getPosts() {
      axios.get("https://graph.facebook.com/v19.0/17841449936861923?fields=name%2Cmedia.limit(8)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Cthumbnail_url%7D&access_token=EAAFNrzoP2TgBAG2W58wxB0OxnZAfTBNfXzTAOKHs17745BwhtRaRv7ZCYMVUbe2nELkzjBMUEOqBbNa7ZCZCfIQ0LJF8ZA41dny6oWr6tjwjKilT0ITsQm8A1uL6z2sS1ZCialeXjwCBmjXxTjL5ZAjiyUcj24xz95GJtSZAEKxKkZBsxTCecsFPoI8SCzkcaKXMZD", {
        params: { per_page: 24 },
      })
      .then((response) => {
        this.posts = response.data.media.data;
      })
      .catch((error) => {
        this.error = error.message; // より具体的なエラーメッセージを設定
      });
    },
  },
  components: {
    'insta-logo': {
      template: `
        <div class="insta_item">
          <a class="insta_logo" href="https://www.instagram.com/kawaishihonke1863/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
          </a>
        </div>
      `,
    }
  }
});

insta.mount("#instafeed");



const swiper = new Swiper(".swiper-container", {
  // ドットインジケーターの表示
  speed: 1000,
  loop: true,
  loopAdditionalSlides: 1,
  initialSlide: 0,
  centeredSlides: false,
  autoplay: {
    delay: 4000,
  },
  paginationClickable: true,
  centeredSlides : true,
  pagination: {
    el: ".swiper-pagination",
  },
  // 前後スライドボタンを表示
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
  },
});


// // onceは一回だけ実行する時用です
// let once = false;
// window.addEventListener('scroll', function () {
//   // ターゲットの画面トップからの距離
//   taeget_position = document
//     .querySelector("#sns")
//     .getBoundingClientRect().top;
//   // 画面トップからの距離から画面の高さより小さければ実行する
//   if (taeget_position <= window.innerHeight && once !== true) {
//       once = true;
//       // インスタ実行
//       insta.mount("#instafeed");
// 		}
// 	});


  // バナー非表示ボタン
document.addEventListener("DOMContentLoaded", function () {
  const closeButtons = document.querySelectorAll(".close-button");

  // ボタンの表示状態を更新する関数
  function updateButtonDisplay(button, buttonId) {
    const hideUntil = localStorage.getItem("hideUntil_" + buttonId);

    try {
      if (hideUntil && new Date(hideUntil) > new Date()) {
        button.style.display = "none";
      } else {
        button.style.display = "block";
      }
    } catch (e) {
      console.error("Error parsing date: ", e);
      button.style.display = "block"; // エラーがある場合はデフォルトで表示
    }
  }

  // 各ボタンに対してイベントリスナーを設定
  closeButtons.forEach((button) => {
    const buttonId = button.dataset.id;
    updateButtonDisplay(button, buttonId);

    button.addEventListener("click", function () {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 7); // 7日間非表示
      localStorage.setItem("hideUntil_" + buttonId, currentDate.toISOString());
      button.style.display = "none";
    });
  });
});
